import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { getSimulated, subscribeSimulated, removeSimulated } from "./simStore";
import { closeCompanyTab } from "./useCompanyOpenTabs";

export function SimulatedTiles({ group }) {
  const [list, setList] = useState(() => getSimulated());

  useEffect(() => {
    return subscribeSimulated(setList);
  }, []);

  const filtered = (list || []).filter(
    (x) => String(x.group || "").toLowerCase() === String(group || "").toLowerCase()
  );
  if (!filtered.length) return null;

  return (
    <div className="companyLov__simRow" aria-label="Simulated entries">
      {filtered.map((s) => (
        <div key={s.id} className="companyLov__simPill">
          <span className="companyLov__simPillDot" />
          <span className="companyLov__simPillName">{s.name}</span>
          <span className="companyLov__simPillBadge">SIM</span>
          <button
            type="button"
            className="companyLov__simPillClose"
            aria-label={`Remove ${s.name}`}
            onClick={() => {
              removeSimulated(s.id);
              closeCompanyTab(`sim:${s.id}`);
            }}
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
